/**
 * Billing settings page component for lite home navigation
 * Only accessible to business owners
 */

import { Stack, Alert, Text } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import SettingsHeader from "@/pages/Settings/SettingsHeader/SettingsHeader";
import Billing from "@/pages/Billing/Billing";
import { useAuthStore } from "@utils/stores/authStore";

interface BillingSettingsPageProps {
  onExit?: () => void;
}

const BillingSettingsPage: React.FC<BillingSettingsPageProps> = () => {
  const { isOwner } = useAuthStore();

  // Restrict access to owners only
  if (!isOwner()) {
    return (
      <Stack gap="md">
        <SettingsHeader
          title="Billing & Plan"
          description="View and update your billing and plan information"
        />
        <Alert variant="light" color="yellow" icon={<IconLock />}>
          <Text size="sm">
            Only business owners can access billing and plan information.
          </Text>
        </Alert>
      </Stack>
    );
  }

  return (
    <Stack gap="md">
      <SettingsHeader
        title="Billing & Plan"
        description="View and update your billing and plan information"
      />
      <Billing loading={false} />
    </Stack>
  );
};

export default BillingSettingsPage;
